import { useGlobalStore } from '@atlas/shared-state';
import { switchBranch } from '@atlas/api-client';

export function useBranch() {
  const currentBranch = useGlobalStore((s) => s.currentBranch);
  const effectiveBranches = useGlobalStore((s) => s.effectiveBranches);
  const hasAllBranches = useGlobalStore((s) => s.hasAllBranches);
  const primaryBranchId = useGlobalStore((s) => s.primaryBranchId);

  return {
    currentBranch,
    effectiveBranches,
    hasAllBranches,
    primaryBranchId,
    hasBranch: currentBranch !== null,
    switchBranch,
  };
}
